var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
var SimpleTooltip = function (_a) {
    var id = _a.id, _b = _a.placement, placement = _b === void 0 ? 'right' : _b, _c = _a.tooltip, tooltip = _c === void 0 ? null : _c, children = _a.children;
    if (!tooltip || !children)
        return children;
    var overlay = useMemo(function () { return _jsx(Tooltip, __assign({ id: id }, { children: tooltip })); }, [id, tooltip]);
    return (_jsx(OverlayTrigger, __assign({ placement: placement, overlay: overlay }, { children: children })));
};
export default SimpleTooltip;
